// Shared helper to compute the stripe color from SpO₂ values for tiles/cards.
// Centralized here so it can be reused across components.
export const getStripeColorFromSpo2 = (spo2) => {
  // Normalize value to a number
  if (spo2 === undefined || spo2 === null || spo2 === "--") {
    return "#B1B1B1";
  }
  const n = Number(String(spo2).replace(/[^0-9.]/g, ""));
  if (Number.isNaN(n)) return "#B1B1B1";

  if (n < 90) return "#F75F56";
  if (n <= 94) return "#FBAE42";
  return "var(--primary-theme-color)";
};


